import React, { useEffect, useState } from 'react';
import ValidatePasswordCreation from '../common/validatePasswordCreation';
import { localStoreFN } from '../../store/localStorage';

const ModalPass = props => {
  const authenticatedUserId = localStoreFN().getItem('userId');
  const [password, setPassword] = useState('');
	const [repeatPassword, setRepeatPassword] = useState('');
	const [currentPassword, setCurrentPassword] = useState('');
  const [passwordIsValid, setPasswordIsValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);

  // if the same user is resetting their password, they are asked to enter their current password
  const isVisibleInputCurrentPassword = (props.config) ? authenticatedUserId.toString() === props.config.id.toString() : false;

  const handlePasswordIsValid = (isValid) => {
    let isValidCurrentPassword = true;

    if (isVisibleInputCurrentPassword) {
      isValidCurrentPassword = currentPassword.length > 0;
    }

    setPasswordIsValid(isValid && isValidCurrentPassword);
  }

  useEffect(() => {
    if (props.modal) {
      initializeState();
    }
  }, [props.modal]);

  const initializeState = () => {
    setCurrentPassword('');
    setPassword('');
    setRepeatPassword('');
    setPasswordIsValid(false);
    setShowPassword(false);
    setShowCurrentPassword(false);
  }

  return (
    <div
      data-close="ok"
      onClick={props.handleModal}
      className={props.modal ? `container-modal` : `container-modal hide`}
    >
      <section className="module-title modal-title">
        <h2>{props.language.account.accountUser.editPassWord}</h2>
        {
          (props.statusSave && (props.statusSave === 500 || props.statusSave === 400)) && (
            <p className="error">
              {props.language.error[`cod${props.dataSave.error.code}`]}
            </p>
          )
        }
        <a>
          <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
        </a>
      </section>
      {props.statusSave != 200 && (
        <div className={`box-modal max500`}>
          <section id="modal-editpass" className="base-form">
            <input type="hidden" defaultValue={props.config.id} id="idpass" />

            {
              // if the same user is resetting their password, they are asked to enter their current password
              (isVisibleInputCurrentPassword) && (
                <div className="box-form islabel">
                  <div>
                    <label className="modal-label">
                      {props.language.account.accountUser.currentPassword}
                      <strong>(*)</strong>{' '}
                    </label>
                  </div>
                  <div className="input-icon-container">
                    <input
                      autoComplete="off"
                      type={showCurrentPassword ? 'text' : 'password'}
                      id="current_passup"
                      className="modal-input"
                      value={currentPassword}
                      onChange={e => setCurrentPassword(e.target.value)}
                    />
                    <i
                      className={`icon fas ${showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'} `}
                      onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    />
                  </div>
                </div>
              )
            }

            <div className="box-form islabel">
              <div>
                <label className="modal-label">
                  {props.language.account.accountUser.newPassword}
                  <strong>(*)</strong>{' '}
                </label>
              </div>
              <div className="input-icon-container">
                <input
                  autoComplete="off"
                  type={showPassword ? 'text' : 'password'}
                  id="passup"
                  className="modal-input"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
                <i
                  className={`icon fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} `}
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
            </div>
            <div className="box-form islabel">
              <div>
                <label className="modal-label">
                  {props.language.account.accountUser.repeatPassword}
                  <strong>(*)</strong>
                </label>
              </div>
              <div className="input-icon-container">
                <input
                  autoComplete="off"
                  type={showPassword ? 'text' : 'password'}
                  id="repeat_passup"
                  className="modal-input"
                  value={repeatPassword}
                  onChange={e => setRepeatPassword(e.target.value)}
                />
                <i
                  className={`icon fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} `}
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
            </div>
            <div className="box-form islabel">
              <ValidatePasswordCreation
                password={password}
                repeatPassword={repeatPassword}
                onPasswordIsValid={handlePasswordIsValid}
                language={props.language}
              />
            </div>
          </section>
        </div>
      )}
      {props.statusSave != 200 && (
        <div className={'box-form islabel top center modal-button-box '}>
          <div>
            {props.loadingSave ? (
              <div className="spiner">
                <i className="fas fa-spinner fa-spin" /> {props.language.account.others.loading}
              </div>
            ) : (
              <input
                className={passwordIsValid ? 'active' : 'disabled'}
                onClick={props.handleSubmit}
                type="button"
                value={props.language.account.accountUser.updatePassword}
                disabled={!passwordIsValid}
              />
            )}
          </div>
        </div>
      )}
      {props.statusSave == 200 && (
        <div className={`box-modal max500`}>
          <section className={'feed-back green'}>
            <div>
              <i className="fas fa-check-circle" />
            </div>
            <div>
              <p>{props.language.account.accountUser.isUpdatePassword}</p>
            </div>
          </section>
        </div>
      )}
    </div>
  )
};

export default ModalPass;



// WEBPACK FOOTER //
// ./source/client/components/account_user/modalPass.jsx